/*eslint-disable no-undef*/
import { connect } from 'react-redux'
import sanitizeHtml from 'sanitize-html'
import * as Jsx from './index.jsx'

/*global translate*/

// const stickerData = global.rootRequire('classes/stickerData.json');
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { rxgetLocal } = global.rootRequire('classes/request')
const { secondToTime, rxaget, formatBytes, rxChangeSlug, subString, changeColorSVG, isLeaderCheck, arraysEqual} = global.rootRequire('classes/ulti')
const {chooseGroupAction, netaMessAdd,updateRecentContactGroups,netaMediaOneAdd, netaGroupsUpdateMessDraft,netaGroupsRemove,netaMessRemove, removeGroupsDraft, changeGroupFunc, netaMessDrafUpdate, changePollsFunc } = global.rootRequire('redux')
const rxio = global.rootRequire('classes/socket').default
const { checkBlock, checkIsOwner, checkNameUser } = global.rootRequire('classes/chat')
const workerGroup = global.rootRequire('classes/globalGroups')
const chatDB = global.rootRequire('classes/indexedDB').default
const workerUnread = global.rootRequire('classes/globalUnread')
const workerUser = global.rootRequire('classes/globalUser')
const worker = global.rootRequire('classes/globalUser')
let zget = global.rxu.get

const maxUser = 30

class FooterComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = global.rootContext(this.props.staticContext) || {
       stickerFolderName: [],
       arrTabsChar:[':',':)',':(',':P',':D',':O',';)','B-)','B|','>:(',':/',":'(",'O:)',':*','3:)','^_^','-_-','o.O','>:O','(y)'],
       displayTagNameBox:false,
       group: rxaget(this.props, 'rxgroup.group', {}),
       group_id: rxaget(this.props, 'rxgroup.groupid', ''),
       groupsTemp:[],
       groupsTagName:[],
       typing:false,
       sender_typing:'',
       tagNameDisplay:{},
       tagNameSelect:'',
       tagNameQuery: '',
       tagNameSelectNum:0,
       tagNameSelect_isFirstTime:true,
       canceRecoreStatus:false,
       status:true,
       isBlocked: false,
       cancelLoadingFile:false,
       displayLikeIcon:true,
       flagPollPopup: false
    }
    
    this.netaGroupsDraft = rxaget(this.props, 'netaGroupsDraft', {})
    // this.users = rxaget(this.props, 'user.users', {})
    this.users = worker.users
    this.keyClickFunction = this.keyClickFunction.bind(this);
    this.mouseClickFunction = this.mouseClickFunction.bind(this);
    this.state.tabmore = rxaget(this.props, 'tabmore', false)
    this.state.groups = rxaget(this.props, 'groups', []) || {}
    this.state.uids = rxaget(this.props, 'user.ids', []) || []
    // this.state.users = rxaget(this.props, 'user.users', {}) || {}
    this.state.users = worker.users
    this.state.mess = ''

    this.state.imageTmp = {}

    this.state.mess_selected = {}

    this.blockEnter = false
    this.lastCaretOffset = -1

    this.state.me_typing = false
    this.state.type_option = 0 
    this.token = rxaget(this.props, 'netaauth.user.token', '')
    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.onClickBlockContact = this.onClickBlockContact.bind(this)
    
    this.draft_mess = {}
    this.blocked_uins = rxaget(this.state.group, 'blocked_uins', [])

    this.checkflagTag = false
    this.checkflagAll = false
    this.checkTypingKeyCode = []

    this.sanitizeConf = {
      allowedTags: ['span', 'b', 'i', 'u', 'br', 'em', 'strong', 'a', 'p', 'h1'],
      allowedAttributes: { a: ['href'], span: ['uid', 'style', 'class'] }
    }
  }

  componentDidMount() {
    this.loadDidMount()
    let isBlocked = checkBlock(this.state.group, this.userid)
    if (isBlocked !== this.state.isBlocked) {
      this.setState({ isBlocked })
    }
    let stickerFolderName = []
    let stickerData = global.rxu.json(rxgetLocal('rxsticker'), {})
    if (stickerData && stickerData.stickerData) {
      stickerData.stickerData.forEach(o => {
        if (o.type && o.type !== 'history' && o.type !== 'EmojiIcon') {
          stickerFolderName.push(o.type)
        }
      })  
    }

    let chatInput = document.getElementById('chat-value')
    chatInput.addEventListener('chooseOption', (e) => {
      if (e.detail && e.detail.pollInfo) {
        let pollType = e.detail.type
        let pollInfo = e.detail.pollInfo
        let pinStatus = false
        switch (pollType) {
          case 'sendPollMess':
            this.sendPollMess(pollInfo, pinStatus, 4) 
            break;
          case 'createPollAnswers':
            this.sendPollMess(pollInfo, pinStatus, 3)
            break;
          case 'finishPoll':
            this.sendPollMess(pollInfo, pinStatus, 2)
            break;
          case 'createPollClick':
            this.createPollClick()
            break;
          // case 'sendPollMess':

          // break;

          default:
            break;
        }

      }
      if (e.detail && e.detail.mess_selected && e.detail) {
        this.setState({
          mess_selected: e.detail.mess_selected,
          type_option: e.detail.type_option
        }, () => {
          var chatDiv = document.getElementById('zmess-box')
          if (chatDiv) {
            chatDiv.focus()  
          }
          
        })
      }
    })

    this.getUsers(this.state.group)

    let upState = {stickerFolderName: stickerFolderName}
    try {
      let groupid = rxaget(this.state.group, 'group_id', '')
      let objMessDraf = rxaget(this.props.netaMessDraf, 'data', '')
      if (groupid && objMessDraf[groupid]) {
        upState['mess'] = objMessDraf[groupid]
      } else {
        upState['mess'] = ''
      }
    } catch(e) {}

    this.setState(upState)
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyClickFunction, false);
    document.removeEventListener("click", this.mouseClickFunction, false);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rxgroup && nextProps.rxgroup.group) {
      let newGroup = nextProps.rxgroup.group

      if (newGroup.group_id !== this.state.group.group_id) {
        const chatDiv = document.getElementById('zmess-box')
        let objState = {}
        if (chatDiv) {
          chatDiv.innerHTML = ''
          objState = { 
            mess: chatDiv.innerHTML,
            displayTagNameBox:false,
            group: newGroup,
            tagNameDisplay : {}
          }

          this.checkflagTag = false
        }

        objState['group_id'] = newGroup.group_id
        objState['typing'] = false
        objState['canceRecoreStatus'] = true

        this.resetTagname()

        let isBlocked = checkBlock(newGroup, this.userid)
        if (isBlocked !== this.state.isBlocked) {
          this.setState({ isBlocked })
        }

        this.getUsers(newGroup)

        this.blocked_uins = JSON.parse(JSON.stringify(rxaget(newGroup, 'blocked_uins', [])))

        let messDraf = ''
        try {
          let groupid = rxaget(newGroup, 'group_id', '')
          let objMessDraf = rxaget(nextProps.netaMessDraf, 'data', '')
          if (groupid && objMessDraf[groupid]) {
            messDraf = objMessDraf[groupid]
          }
        } catch(e) {}

        this.setState({
          typing: false,
          objState: objState,
          group: newGroup,
          mess: messDraf,
          group_id: nextProps.rxgroup.group.group_id
        })

      } else if (!arraysEqual(rxaget(newGroup, 'blocked_uins', []), this.blocked_uins ) ) {
        let isBlocked = checkBlock(newGroup, this.userid)

        this.blocked_uins = JSON.parse(JSON.stringify(rxaget(newGroup, 'blocked_uins', [])))

        this.setState({
          isBlocked: isBlocked,
          group: newGroup,
          group_id: newGroup.group_id
        })
      }
    }


    // if(this.state.cancelLoadingFile !== nextProps.cancelLoadingFile){
    //   let cancelLoadingFile = nextProps.cancelLoadingFile
      
    //   this.setState({cancelLoadingFile:cancelLoadingFile})
    // }
    

    // // if(this.state.mess_selected && this.state.mess_selected.message_id){
    // //   if (this.state.mess_selected.message_id !== nextProps.mess_selected.message_id && this.state.type_option !== 0) {
    // //     this.closeReplyMessage()
    // //   }      
    // // }
    // if (( nextProps.rxgroup && nextProps.rxgroup.group && nextProps.rxgroup.group.occupants_uins) || (nextProps.user.users && this.state.users && (Object.keys(nextProps.user.users).length !== Object.keys(this.state.users).length))) {
    //   let groupId = (nextProps.rxgroup && nextProps.rxgroup.group && nextProps.rxgroup.group.occupants_uins)
    //   let users = JSON.parse(JSON.stringify((nextProps.user && nextProps.user.users) || this.state.users))

    //   this.setState({  users })
    // }
    // if( this.state.tabmore !== nextProps.tabmore){
    //   let tabmore = nextProps.tabmore
    //   this.setState({tabmore :tabmore})
    // }
    // if (nextProps && nextProps.mess_selected && nextProps.mess_selected.message_id) {
    //   this.setState({ mess_selected: nextProps.mess_selected, type_option: nextProps.type_option }, () => {
    //     try {
    //       const chatDivFoward = document.getElementById('zmess-box')
    //       chatDivFoward.focus()
    //       chatDivFowardd.select()
    //     } catch(e5) {}
    //   })
    // }
    // if (nextProps.type_option === 0) {
    //   this.setState({ mess_selected: {}, type_option: 0 })
    // }
    // if (this.state.group) {  
    //   let groupObj = this.state.group || {}
    //   if (typeof(groupObj.group_id) === 'undefined') {
    //     groupObj = rxaget(this.props, 'rxgroup.group', {})
    //   } else if (groupObj.isDraft && this.props.rxgroup && this.props.rxgroup.group && this.props.rxgroup.group.group_id == groupObj.group_id && typeof(this.props.rxgroup.group.isDraft) === 'undefined') {
    //     groupObj = rxaget(this.props, 'rxgroup.group', {})
    //   }

    //   if (groupObj.group_id !== nextProps.group_id) {
    //     const chatDiv = document.getElementById('zmess-box')
    //     if (chatDiv) {
    //       if (this.state.mess.length > 0 ) {
    //         if (groupObj.isDraft) {
    //           const draft_mess = {
    //             'created_at': new Date().getTime() * 1000,
    //             'message': this.state.mess,
    //             'group_fullname': (groupObj.fullnamegroup) ?  groupObj.fullnamegroup : groupObj.group_fullname || ''
    //           }
    //           this.props.netaGroupsUpdateMessDraft(groupObj.group_id,draft_mess)  
    //         }    
    //       } else {
    //         if(this.netaGroupsDraft && this.netaGroupsDraft.groups && groupObj.group_id && this.netaGroupsDraft.groups[groupObj.group_id]){
    //           this.deleteGroup(groupObj)
    //           this.props.removeGroupsDraft(groupObj.group_id) 
    //         } else {
    //           // if (nextProps && nextProps.netaGroups && nextProps.netaGroups.groups && nextProps.netaGroups.groups[groupObj.group_id] &&  nextProps.netaGroups.groups[groupObj.group_id]['isDraft']) {
    //             this.deleteGroup(groupObj)
    //             this.props.removeGroupsDraft(groupObj.group_id)  
    //           // }
    //         }
    //       }

    //       const groupCheckDraft = nextProps.rxgroup.group
    //       if(groupCheckDraft.draft_mess && groupCheckDraft.draft_mess.message && groupCheckDraft.draft_mess.message.length > 0){
    //         chatDiv.innerHTML = groupCheckDraft.draft_mess.message
    //       }else{
    //         chatDiv.innerHTML = ''
    //       }
    //       if (this.draft_mess && this.draft_mess[nextProps.group_id]) {
    //         chatDiv.innerHTML = this.draft_mess[nextProps.group_id]
    //       }
    //       this.setState({ 
    //         mess: chatDiv.innerHTML,
    //         displayTagNameBox:false,
    //         group: nextProps.rxgroup.group,
    //         tagNameDisplay : {}
    //       })
    //     }   
    //   }
    // }
  }

  async createPollClick(){
    let group_id = this.state.group_id
    let polls = await chatDB.polls.get({group_id:group_id.toString()})
    if(polls && polls.data && polls.data.length >= 5){
      alert(translate('You can only create up to 5 poll'))
    }else{
      this.setState({ flagPollPopup: true })
    }
  }
  getUsers(group) {
    if (group && group.occupants_uins && group.occupants_uins.constructor === Array && group.occupants_uins.length > 0) {
      let occupantsUins = group.occupants_uins.map(o => Number(o)).sort()
      chatDB.users.bulkGet(occupantsUins).then(arrUserInDB => {
        for (let u of arrUserInDB) {
          if (u && u.id) {
            this.users[u.id] = u
          }
        }
      }).catch(e => {
        console.log(e)
      })
    }
    
  }

  deleteGroup(groupObjTmp=null) {
    let groupObj = groupObjTmp
    if (groupObj && groupObj.group_id) {
      if (rxio.connected) {
        const msgUpGroup = {
          group_id: Number(groupObj.group_id)
        }
        let groupsStore = this.props.netaGroups
        this.props.netaGroupsRemove(groupObj.group_id)
        this.props.netaMessRemove(groupObj.group_id)
        if (groupsStore && groupsStore.groups) {
          let arrGroups = Object.keys(groupsStore.groups)
          if (arrGroups.constructor === Array && arrGroups.length > 1) {
            arrGroups = arrGroups.filter(groupid => groupid !== groupObj.group_id.toString())
            if (groupsStore.groups && groupsStore.groups[arrGroups[0]]) {
              this.props.chooseGroupAction(groupsStore.groups[arrGroups[0]])
            }
          } 

          if ([0,1].indexOf(arrGroups.length) !== -1)  {
            this.props.chooseGroupAction({group_id: ''})
          }
        } else {
          this.props.chooseGroupAction({group_id: ''})
        }
      }
    }
  }

  onClickBlockContact() {
    const group = JSON.parse(JSON.stringify(this.state.group))
    let that = this
    let isBlocked = this.state.isBlocked
    if([1,3].indexOf(isBlocked) !== -1){      
      rxio.unblockUser({ group_id: group.group_id, uni: group.partner_id}, () => {
        let blocked_uins = group.blocked_uins

        for(let i = 0; i < blocked_uins.length; i++){
          if(blocked_uins[i] === group.partner_id){
            blocked_uins.splice(i,1)
          }else{
            // console.log(blocked_uins[i] , group.partner_id,'cai gi day')
          }
        }
        group.blocked_uins = blocked_uins
        that.props.chooseGroupAction(group)
      })
    }
    if([0,2].indexOf(isBlocked) !== -1 ){
      rxio.blockUser({ group_id: group.group_id, uni: group.partner_id}, () => {        
        let blocked_uins = group.blocked_uins

        blocked_uins.push(group.partner_id)
        group.blocked_uins = blocked_uins
        that.props.chooseGroupAction(group)
      })
    }

    this.setState({ displayAskBlock: false })
  }
  
  clearMessBox(){
    const chatDiv = document.getElementById('zmess-box')
    chatDiv.innerHTML=''
  }

  removeTags(str) { 
    if ((str===null) || (str==='')) {
      return false
    } else {
      str = str.toString()
    }

    str = str.replace(/<b>([\s\S]*?)<\/b>/g, '[b]$1[/b]')
    str = str.replace(/<i>([\s\S]*?)<\/i>/g, '[i]$1[/i]')
    str = str.replace(/<u>([\s\S]*?)<\/u>/g, '[u]$1[/u]')

    return str.replace( /(<([^>]+)>)/ig, '')
  } 

  loadHandleSocket() {
    rxio.getWaitConnect((data) => {
      if (data) {
        rxio.getWaitEvent((data) => {
          this.handleEvent(data)
          this.handleMessage(data)
        })
        rxio.getWaitMessage((data) => {
          if (data && data.message && (data.message.indexOf(this.userid.toString()) !== -1 || data.message.toLowerCase().indexOf('@all') !== -1)) {
            chatDB.groups.get({group_id: data.group_id.toString()}).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  my_messid_tag: data.message_id
                }
                chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup)
              }
            })
          }
          this.handleMessage(data, true)
        })
        rxio.getWaitMessDel((data) => {
          this.handleMessage(data, false)
        })
        rxio.getEmojiEvent((data) => {
          this.handleMessage(data);
          // this.handleEvent(data)
        })
      } else {
        setTimeout(() => {
          this.loadHandleSocket()  
        }, 300)
      }
    }) 
  }

  loadDidMount() {
    document.addEventListener("keydown", this.keyClickFunction, false);   
    document.addEventListener("click", this.mouseClickFunction, false); 

    if (this.token && this.userid) {
      if (!rxio.connected && !rxio.init_connected) {
        rxio.login(this.token, this.userid, (data) => {
          rxio.getWaitEvent((data) => {
            this.handleEvent(data)
          })
          rxio.getEmojiEvent((data) => {
            this.handleMessage(data);
            // this.handleEvent(data)
          })
          rxio.getWaitMessage((data) => {
            this.handleMessage(data, true)
          })
          rxio.getWaitMessDel((data) => {
            this.handleMessage(data, false)
          })
        })
      } else {
        this.loadHandleSocket()
      }
    }
    this.setState.messReply = this.props.messReply
  }

  pasteEventFunction= (e) =>{
    let paste = (e.clipboardData || window.clipboardData).getData('text');

    const chatDiv = document.getElementById('zmess-box')    
    if (chatDiv) {
      chatDiv.innerHTML += paste 

      this.setState({ 
        mess: chatDiv.innerHTML,
       })
    }
    e.preventDefault();    
    this.setCursor(e.currentTarget.textContent.length)
  }

  keyClickFunction(event){
    if(event.keyCode === 27) {
      this.closeReplyMessage()
    }
  }

  mouseClickFunction(event){
    const menuDiv = document.getElementById('menu-message')
    // const groupPopup = document.getElementById('popup-group')
    if (menuDiv && event.target !== menuDiv && menuDiv.style.display === 'block') {
      menuDiv.style.display = 'none'
    }
  
    if(this.state.displayTagNameBox){
      this.checkflagTag = false
      this.setState({displayTagNameBox:false})  
    }

    if (event.srcElement.className !== 'menu-option-footer') {
      const menuDiv = document.getElementById('menu-footer')
      if (menuDiv) {
        menuDiv.style.display = 'none'
      }
    }    
  }

  closeReplyMessage() {
    this.setState({ mess_selected: {}, type_option: 0 })
    this.resetSelectedMess()
  }

  convertTagName(message) {
    // let userstag = message.match(/(@\d+\b)/ig)
    // if (userstag && userstag.constructor === Array && userstag.length > 0) {
    //   userstag.forEach(o => {
    //     let useridtmp = o.replace('@', '') || ''
    //     if (this.users[useridtmp]) {
    //       let useridtmp_group = this.getGroupByUserId(useridtmp)
    //       if(useridtmp_group  && useridtmp_group .group_id){
    //         window[useridtmp_group.group_id] = useridtmp_group  
    //       }
          
    //       message = message.replace(o, '<b onClick="ClickInfoUser(' + useridtmp + ',' + this.userid + ',' + useridtmp_group.group_id +')">' + checkNameUser(rxaget(this.users, useridtmp, {})) + '</b>')
    //     }
    //   })
    // }
    return message
  }

  resetSelectedMess() {
    this.setState({ type_option: 0, mess_selected: {}, mess_id: '' })
  }

  closeImageFooterLoader() {
    this.setState({ imageTmp: {}, mess: '' })
  }

  closePopupGroup() {
    this.setState({ popupGroup: false })
  }

  chooseGroupForward(group) {
    this.setState({ popupGroup: false, type_option: 2 }, () => {
      this.chooseGroup(group)
    })
  }

  chooseOption(e, type) {
    let option = 0
    let popupGroup = false
    if (type === 'reply') {
      option = 1
    } else if (type === 'delete_all') {
      this.deleteMessage(true)
    } else if (type === 'delete_one') {
      this.deleteMessage(false)
    } else if (type === 'copy') {
      this.copyTextToClipboard(rxaget(this.state, 'mess_selected.message', ''))
    } else if (type === 'forward') {
      popupGroup = true
    }
    this.setState({ type_option: option, popupGroup: popupGroup })
  }

  copyTextToClipboard(text) {
    let textArea = document.createElement('textarea')
    textArea.style.position = 'fixed'
    textArea.style.top = 0
    textArea.style.left = 0
    textArea.style.width = '2px'
    textArea.style.height = '2px'
    textArea.style.padding = 0
    textArea.style.border = 'none'
    textArea.style.outline = 'none'
    textArea.style.boxShadow = 'none'
    textArea.style.background = 'transparent'
    textArea.value = text.replace(/[\t\r\n]/g, '')
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      document.execCommand('copy')
    } catch (err) {
      console.log('Oops, unable to copy')
    }

    document.body.removeChild(textArea)
  }

  checkTypeDelMess() {
    let result = 0
    if (rxaget(this.state, 'mess_selected.sender_uin', '').toString() === this.userid.toString()) {
      result = 1
    }
    if (rxaget(this.state, 'mess_selected.status', 0) === 4) {
      result = 2
    }
    if (rxaget(this.state, 'mess_selected.deleted_uins', []).indexOf(this.userid.toString()) !== -1) {
      result = 2
    }
    if (rxaget(this.state, 'mess_selected.message', '') !== '') {
      result = 3
    }

    return result
  }

  handleEvent(data) {
    if (data && data.type === 9) {
      const sender = this.state.users[data.sender_uin]
      if ((data.group_id === this.state.group_id) && sender && this.userid.toString() !== data.sender_uin) {
        let sender_name = checkNameUser(sender)
        this.setState({ typing: true, sender_typing: sender_name }, () => {
          setTimeout(() => {
            this.setState({ typing: false, sender_typing: '' })  
          }, 5000)
        })
      }else{
        this.setState({ typing: false })
      }
    }
    if (data && data.type === 10) {
      this.setState({ typing: false })
      /* if ((data.group_id === this.state.group_id)) {
        this.setState({ typing: false })
      }*/
    }
  }

  clickRecord(isClick){    
    if(isClick && this.state.canceRecoreStatus === true){
      this.setState({
         canceRecoreStatus: false
      })
    }
  }

  uploadFile(arrImg, type, mess) {
    const arrUsers = this.state.users
    const group_id = this.state.group_id
    const user = rxaget(this.props, 'netaauth.user', {})
    const objUser = arrUsers[user.id.toString()]
    let msg = {}
    if (type === 'image') {
      if (arrImg && arrImg.constructor === Array && arrImg.length > 0) {
        msg = {
          group_id: Number(group_id),
          type: 2,
          version: 1,
          nonce: (Math.floor(Date.now()) * 1000).toString(),
          sender_name: rxaget(objUser, 'full_name', ''),
          attachments: JSON.stringify({ images: arrImg }).replace(/"/g, '\\"')
        }
        this.updateFilePer(arrImg, type, mess, msg)
      }
    }
    if (type === 'video') {
      if (arrImg && arrImg.constructor === Array && arrImg.length > 0) {
        for (let objFile of arrImg) {
          msg = {
            group_id: Number(group_id),
            type: 4,
            version: 1,
            nonce: (Math.floor(Date.now()) * 1000).toString(),
            sender_name: rxaget(objUser, 'full_name', ''),
            attachments: JSON.stringify({ video: objFile }).replace(/"/g, '\\"')
          }

          this.updateFilePer(arrImg, type, mess, msg)
        } 
      }
    }
    if (type === 'file') {
      if (arrImg && arrImg.constructor === Array && arrImg.length > 0) {
        for (let objFile of arrImg) {
          msg = {
            group_id: Number(group_id),
            type: 12,
            version: 1,
            nonce: (Math.floor(Date.now()) * 1000).toString(),
            sender_name: rxaget(objUser, 'full_name', ''),
            attachments: JSON.stringify({ file: objFile }).replace(/"/g, '\\"')
          }
          this.updateFilePer(arrImg, type, mess, msg)    
        }
      }
    }
    if (type === 'audio') {
      if (arrImg && arrImg.constructor === Array && arrImg.length > 0 && this.state.canceRecoreStatus === false) {
        msg = {
          group_id: Number(group_id),
          type: 3,
          version: 1,
          nonce: (Math.floor(Date.now()) * 1000).toString(),
          sender_name: rxaget(objUser, 'full_name', ''),
          attachments: JSON.stringify({ audio: arrImg[0] }).replace(/"/g, '\\"')
        }
      }
    }
  }

  updateFilePer(arrImg, type, mess, msg) {
    if (mess) { msg.message = mess }
    let group_id = msg.group_id
    if (msg && msg.group_id) {
      if (rxio.connected) {
        if (msg && msg.message) {
          if (msg.message.indexOf('&') !== -1) {
            msg.message = msg.message.replace(/\&amp\;/g,'&').replace(/\&lt\;/g,'<').replace(/\&gt\;/g,'>')  
          }
          if (msg.message.indexOf('\\\\\\\"') !== -1) {
            msg.message = msg.message.replace(/\\\\\\\"/g, '\\\"')
          }
        }
        this.props.netaMessDrafUpdate(msg.group_id, '')
        this.checkflagAll = false
        rxio.socket.emit('create_message', msg, (data) => {
          if (data && data.message) {
            this.blockEnter = false
            try {
              if (data.message.message_id) {
                chatDB.groups.get({group_id: group_id}).then(groupInDB => {
                  if (groupInDB) {
                    let paramsUpdateGroup = {
                      last_message: data.message,
                      last_message_id: data.message.message_id,
                      last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + data.message.created_at,
                      count_unread: 0
                    }
                    workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                    chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                      this.props.changeGroupFunc()
                    }).catch(e => {})
                  }
                })  
              }

              let objMedia = {
                group_id: Number(group_id),
                media_type: msg.type,
                message_id: Number(data.message.message_id),
                msg_create_at: Number(data.message.created_at),
                url: rxaget(arrImg, '0.url', '')
              }
              if (type === 'file') {
                objMedia['name'] = rxaget(arrImg, '0.file_name', '')
                objMedia['ext'] = rxaget(arrImg, '0.file_extension', '')
              }
              if (type === 'video') {
                objMedia['thumbnail_url'] = ''
              }
              this.props.netaMediaOneAdd(Number(group_id), objMedia)
            } catch(e) {
              console.log(e)
            }

            this.handleMessage(data.message, true)
          }
        })  
      }
      
    }
  }

  parseMessage(objmsg, type) {
    let message = ''
    let attachments = {}
    const userid = rxaget(this.props, 'netaauth.user.id', '').toString()
    const blobs = rxaget(this.props, 'netaBlobs.data', {})
    const created_at = Math.floor(Date.now() / 1000)
    if (objmsg) {
      if (!isNaN(objmsg.type)) {
        try {
          attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, ''))
        } catch (e) {
          if (typeof (rxaget(objmsg, 'attachments', '')) === 'object') {
            attachments = rxaget(objmsg, 'attachments', '')
          }
        }
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = ''
          } else {
            let mess =''
            switch (objmsg.type) {
              case 1:
                let call_name = ''
                let icon_call_name = ''
                if (attachments.media_type === 1) {
                  call_name = translate('Voice call')
                  icon_call_name = 'icon-phone'
                } else if (attachments.media_type === 2) {
                  call_name = translate('Video call')
                  icon_call_name = 'icon-camrecorder'
                }

                let iconcall = ''
                let stylecall = ''
                if (rxaget(attachments, 'caller_uin', '') === this.userid.toString()) {
                  iconcall = 'icon-call-out'
                  if (zget(this.props, 'themeValue')==='blueColor'){
                    stylecall = '#f7f0f7'  
                  }else{
                    stylecall = '#fde4d8'  
                  }
                  
                } else {
                  iconcall = 'icon-call-in'
                  if (zget(this.props, 'themeValue')==='blueColor'){
                    stylecall = '#f7f0f7'  
                  }else{
                    stylecall = '#fdf2ea'
                  }
                  
                }

                message = `<div class='zchat-callmess' style='background: ${stylecall};'>
                  <div class='zchat-callname'>${call_name}</div>`

                if (attachments.accepted_at === '0') {
                  message += `<div class='zchat-calltime' style="color:#d5192d;"><i class='${iconcall}'></i>${translate('Canceled')}</div>`
                } else {
                  const time = Number(rxaget(attachments, 'stopped_at', 0)) - Number(rxaget(attachments, 'accepted_at', 0))
                  message += `<div class='zchat-calltime'><i class='${iconcall}' style="color:#2fb13e;"></i>${secondToTime(time)}</div>`
                }

                message += `<span class='zchat-callicon'><i class='${icon_call_name}'></i></span></div>`

                if (type === 'desc') {
                  mess =  translate(' finished')
                  message = call_name + mess
                }

                break
              case 2:
                try {
                  if (attachments && attachments.images && attachments.images.constructor === Array && attachments.images.length > 0) {
                    let arrurlimgs = rxaget(attachments, 'images', []).map(o => o.url)
                    let strurlimgs = (arrurlimgs && arrurlimgs.constructor === Array && arrurlimgs.length > 0) ? arrurlimgs.join(',') : ''
                    message = '<div class="img-message-row ">'
                    let indeximg = 0
                    for (const img of attachments.images) {
                      message += `<img src='${global.rxu.config.get_static + img.url}' alt='' class='img-message' onclick=window.showGallery('${strurlimgs}','${indeximg}') />`
                      indeximg += 1
                    }
                    message += '</div>'
                    if (type === 'desc') {
                      message = translate('Image')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                /* try {
                  if (attachments && attachments.images && attachments.images.constructor === Array && attachments.images.length > 0) {
                    let arrurlimgs = rxaget(attachments, 'images', []).map(o => o.url)
                    let strurlimgs = (arrurlimgs && arrurlimgs.constructor === Array && arrurlimgs.length > 0) ? arrurlimgs.join(',') : ''

                    message = '<div class="img-message-row">'
                    let indeximg = 0
                    for (const img of attachments.images) {
                      if (img && img.url) {
                        const src = global.rxu.config.get_blobs + '/' + img.url
                        const url_img = img.url || ''
                        if (blobs && blobs[url_img] && blobs[url_img]['created_at'] && (created_at - blobs[url_img]['created_at']) <= 43200) {
                          message += `<img src='${blobs[url_img]['link']}' alt='sticker' class='img-message' onclick=window.showGallery("${strurlimgs}","${indeximg}") />`
                        } else {
                          this.fetchImage(src, (data) => {
                            if (data) {
                              const images = document.getElementsByClassName('img-message')
                              if (images && images.length > 0) {
                                for (let i = 0; i < images.length; i++) {
                                  const valueAttr = images[i].getAttribute('data-id')
                                  const eleid = 'message' + img.url
                                  if (eleid === valueAttr) {
                                    images[i].src = data
                                  }
                                }
                              }
                            }
                          })
                          message += `<img src='./images/default/static/no-image.jpg' data-id='${'message' + img.url}' alt='sticker' class='img-message' onclick=window.showGallery("${strurlimgs}","${indeximg}") />`

                        }
                      }
                      indeximg += 1
                    }
                    message += '</div>'

                    if (type === 'desc') {
                      message = translate('Image')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }*/
                break
              case 3:
                const url = rxaget(attachments, 'audio.url', '')
                const src = global.rxu.config.get_blobs + '/' + url
                message = `<div class='zchat-audiomess'>`

                  message += `
                  <div class='zchat-audioicon' onclick=window.playAudio('icon-audio-${rxaget(objmsg, 'message_id', '').toString()}')>
                    <img class='filter_img_class' id='icon-audio-${rxaget(objmsg, 'message_id', '').toString()}'  src='./images/default/static/icon-media-play.svg'/>
                  </div>
                  `
                message += `

                  <div class='zchat-audiobar'>
                    <div class='zchat-audioprocess' id='process-audio-${rxaget(objmsg, 'message_id', '').toString()}'>
                    </div>
                  </div>
                  <div class='zchat-audiotime'>
                    ${secondToTime(rxaget(attachments, 'audio.duration', 0))}
                  </div>
                `

                if (blobs && blobs[url] && blobs[url]['created_at'] && (created_at - blobs[url]['created_at']) <= 43200) {
                  message += `
                    <audio id='${'audio-' + objmsg.message_id}'>
                      <source id='${'audio' + url}' src='${blobs[url]['link']}' />
                    </audio>
                  `
                } else {
                  this.fetchImage(src, (data) => {
                    if (data) {
                      const eleaudio = document.getElementById('audio' + url)
                      const eleLoadAudio = document.getElementById('audio' + objmsg.message_id)
                      if (eleaudio && eleLoadAudio) {
                        eleaudio.src = data
                        eleLoadAudio.load()
                      }
                    }
                  })
                  message += `
                    <audio id='${'audio' + objmsg.message_id}' >
                      <source id='${'audio' + url}' src='' />
                    </audio>
                  `
                }


                message += `</div>`

                if (type === 'desc') {
                  message = 'Audio'
                }
                break
              case 4:
                try {
                  if (attachments && attachments.video && attachments.video.url) {
                    const url = attachments.video.url
                    const src = global.rxu.config.get_blobs + '/' + url
                    message = '<div class="img-message-row">'
                    if (blobs && blobs[url] && blobs[url]['created_at'] && (created_at - blobs[url]['created_at']) <= 43200) {
                      message += `
                        <video id='${'video' + objmsg.message_id}' width='320' controls='controls' preload='metadata'>
                          <source id='${'video' + url}' src='${blobs[url]['link']}' />
                          Your browser does not support HTML5 video.
                        </video>
                      `
                    } else {
                      this.fetchImage(src, (data) => {
                        if (data) {
                          const elevideo = document.getElementById('video' + url)
                          const eleLoadVideo = document.getElementById('video' + objmsg.message_id)
                          if (elevideo) {
                            elevideo.src = data
                            eleLoadVideo.load()
                          }
                        }
                      })
                      message += `
                        <video id='${'video' + objmsg.message_id}' width='320' controls='controls' preload='metadata'>
                          <source id='${'video' + url}' src="./images/default/static/no-image.jpg" />
                          Your browser does not support HTML5 video.
                        </video>
                      `
                    }

                    message += '</div>'

                    if (type === 'desc') {
                      message = 'Video'
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 5:
                mess = translate(' created a group')
                message = checkNameUser(rxaget(this.users, objmsg.sender_uin, {})) + mess
                break
              case 6:
                const userins = []
                try {
                  if (attachments && attachments.type === 'update_group' && attachments.added_uins && attachments.added_uins.constructor === Array && attachments.added_uins.length > 0) {
                    for (const uid of attachments.added_uins) {
                      const uname = checkNameUser(rxaget(this.users, uid, {}))
                      if (uname) {
                        userins.push(uname)
                      }
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                if (userins.length > 0) {
                  mess = translate(' added ')
                  message = checkNameUser(rxaget(this.users, objmsg.sender_uin, {})) + mess + userins.join(', ')
                }
                break
              case 7:
                mess = translate(' has left the group')
                message = checkNameUser(rxaget(this.users,objmsg.sender_uin, {})) + mess
                break
              case 8:               
                message = '<div class=\'row-reply\'>'
                message += `<div class='sender-reply'> <img class='filter_img_class' alt='icon-reply' src='./images/default/icons/reply-icon.svg'> ${translate('Answer for')} ${checkNameUser(rxaget(this.users, attachments.sender_uin, {})) || ''} </div>`
                
                if (attachments.type === 8 || attachments.type === 9) {
                  attachments.type = 0
                }
                const attachments_tmp = this.parseMessage(attachments)
                if (attachments_tmp !== '') {
                  if (attachments.type === 0) {
                    if(checkIsOwner(objmsg, this.userid)){
                      message += `
                        <div class='message-reply'>
                          <div></div>
                          <div class='message-reply_content_right overflowText'>
                            ${attachments_tmp}
                          </div>
                        </div>`                     
                      }  else{
                           message += `
                            <div class='message-reply'>
                              <div></div>
                              <div class='message-reply_content overflowText'>
                                ${attachments_tmp}
                              </div>
                            </div>`
                    }

                  } else {      
                    let message_reply_content_class = ''
                    let file_reply_content_class = ''
                    if(attachments_tmp.indexOf('img-message-row')!== -1 || attachments_tmp.indexOf('zchat-filemess')!== -1 || attachments_tmp.indexOf('zchat-audiomess')!== -1){                      
                      file_reply_content_class = ' file-reply_content'

                    }
                    if (checkIsOwner(objmsg, this.userid)) {
                      message_reply_content_class = 'message-reply_content_right overflowText' + file_reply_content_class
                    } else {
                      message_reply_content_class = 'message-reply_content overflowText' + file_reply_content_class
                    }

                    message += `
                        <div class='message-reply'>
                          <div></div>
                          <div class='${message_reply_content_class}'>
                            ${attachments_tmp}
                          </div>
                        </div>`

                  }
                }else{
                  if(checkIsOwner(objmsg, this.userid)){
                  message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content_right' >
                        &nbsp;
                      </div>
                    </div>`
                  }
                  else{
                  message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content'>
                        &nbsp;
                      </div>
                    </div>`
                  }
                }
                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {
                  message += '<div class=\'zmessage-reply-anwser my_message overflowText\'>' + this.convertTagName(objmsg.message)+ '</div>' || ''
                } else {
                  if (objmsg.message.length === 0){
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&#160</div></div>' || ''
                  }
                  else{
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box overflowText\'>' +this.convertTagName(objmsg.message) + '</div></div>' || ''  
                  }
                  
                }
                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 9:
                let sender_name 
                let sender_name_mess =translate('You')

                sender_name = checkIsOwner(attachments, this.userid) ? sender_name_mess : checkNameUser(rxaget(this.users,objmsg.sender_uin, {}))
                                
                message = '<div class=\'row-reply\'>'
                message += `<div class='sender-reply'> <img class = 'filter_img_class' alt='icon-reply' src="./images/default/icons/forward-icon.svg"/> ${sender_name || ''} ${translate('forwarded a message')} </div>`  
                if (attachments.type === 8 || attachments.type === 9) {
                  attachments.type = 0
                }
                const attachments_forward = this.parseMessage(attachments)
                if (attachments_forward !== '') {
                    let message_reply_content_class = ''
                    let file_reply_content_class = ''
                    if(attachments_forward.indexOf('img-message-row')!== -1 || attachments_forward.indexOf('zchat-filemess')!== -1 || attachments_forward.indexOf('zchat-audiomess')!== -1){                      
                      file_reply_content_class = ' file-reply_content'

                    }
                    if (checkIsOwner(objmsg, this.userid)) {
                      message_reply_content_class = 'message-reply_content_right overflowText' + file_reply_content_class
                    } else {
                      message_reply_content_class = 'message-reply_content overflowText' + file_reply_content_class
                    }

                    message += `
                        <div class='message-reply'>
                          <div></div>
                          <div class='${message_reply_content_class}''>
                            ${attachments_forward}
                          </div>
                        </div>`
                }else{
                  if(checkIsOwner(objmsg, this.userid)){
                  message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content_right' >
                        &nbsp;
                      </div>
                    </div>`
                  }
                  else{
                  message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content'>
                        &nbsp;
                      </div>
                    </div>`
                  }
                }

                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {
                  if (objmsg.message) {
                    message += '<div class=\'zmessage-reply-anwser my_message overflowText\'>'+this.convertTagName(objmsg.message)+ '</div>' || ''  
                  } else {
                    message += '<div class=\'zmessage-reply-anwser overflowText\'></div>' || ''
                  }
                } else {                 
                  if (objmsg.message.length === 0){
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&#160</div></div>' || ''
                  }
                  else{
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box overflowText\'>' + this.convertTagName(objmsg.message) + '</div></div>' || ''  
                  }
                }

                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 10:
                try {
                  if (attachments && attachments.sticker) {
                    const namesticker = attachments.sticker || ''
                    const arrsticker = this.state.stickerFolderName
                    for (const sticker of arrsticker) {
                      if (namesticker && namesticker.indexOf(sticker) !== -1) {
                        const imgsticker = namesticker.replace(sticker + '_', '')
                        message = `<img src='./images/default/sticker/${sticker}/${imgsticker}' alt='sticker' class='img-sticker' />`
                        break
                      }
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                if (type === 'desc') {
                  message = 'Sticker'
                }
                break
              case 12:
                let file = (attachments && attachments.file) || objmsg.file
                if (file) {
                  message = `<div class='zchat-filemess'>
                  <div class='zchat-callname'>${rxaget(file, 'file_name', '')}</div>`
                  message += `<div class='zchat-calltime' style="color:#a6a6a7;">${formatBytes(rxaget(file, 'size', 0))}</div>`
                  message += `<span class='zchat-docicon' onclick=window.downloadFile('${rxaget(file, 'url', '').toString()}','${rxaget(file, 'file_name', '').toString()}')><i class='icon-doc'></i></span></div>`
                  if (type === 'desc') {
                    message = translate('File')
                  }
                }
                break
              default:
                message = objmsg.message || ''
                if (message && message.length < 50) {
                  let resMess = message.match(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g)
                  if (resMess && resMess.constructor === Array && resMess.length > 0) {
                    let uniemoji = [...new Set(resMess)]
                    for (let emoji of uniemoji) {
                      let regEmoji = new RegExp(emoji, 'g')
                      message = message.replace(regEmoji, '<span>' + emoji + '</span>')
                    }
                  }
                }

                break
            }
          }
        } else {
          message = ''
        }
      } else {
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = ''
          } else {
            message = objmsg.message || ''
          }
        } else {
          message = ''
        }
      }

      if (message.indexOf('@') !== -1) {
        let userstag = message.match(/(@\d+\b)/ig)
        if (userstag && userstag.constructor === Array && userstag.length > 0) {       
          userstag.forEach(o => {
            let useridtmp = o.replace('@', '') || ''           
            if (this.users[useridtmp]) {
              message = message.replace(o, checkNameUser(rxaget(this.users, useridtmp, {})))
            }
          })
        }
      }
      if (message && message.indexOf('\\n') !== -1) {
        // message = message.replace(/\\n/g, '</br>')
      }
      if (message.indexOf('[') !== -1) {
        message = message.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<span class="bbcode-bold">$1</span>')
        message = message.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
        message = message.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
      }
      return message
    } else {
      return ''
    }
  }

  pasteAsPlainText = e => {
    e.preventDefault()

    if (e.clipboardData.files.length > 0) {
      let contentTarget = document.getElementById('zmess-box')

      this.retrieveImageFromClipboardAsBase64(e, (imageObj) => {
        if(imageObj){
          // let messtmp = `<img src='${imageObj['base64']}' alt='image' class='load-image-footer' />`

          contentTarget.innerHTML = `<img src='${imageObj['base64']}'>`
          this.setState({
            imageTmp: imageObj
          })
        }
      })
    } else {
      let text = e.clipboardData.getData('text/html')
      if  (text.indexOf('bbcode-bold') !== -1) {
        text = text.replace(/<span class="bbcode-bold".*?>([\s\S]*?)<\/span>/gi, '<b>$1</b>')
      }
      if (text) {
        text = text.replace(/<span(?:(?!uid).)*?>/g, '<span>')
      }
      let newText = sanitizeHtml(text, this.sanitizeConf).replace(/<p>/gi, '').replace(/<\/p>/gi, '\n').replace(/&nbsp;/g, ' ').replace(/\xA0/g,' ')
      if (!newText) {
        newText = e.clipboardData.getData('text/plain')
      }
      if (newText) {
        newText = newText.trim()
        if (newText.indexOf('[') !== -1) {
          newText = newText.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<b>$1</b>')
          newText = newText.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
          newText = newText.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
        }
      }
      document.execCommand('insertHTML', false, newText)
    }
  }

  retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat){
    if(pasteEvent.clipboardData === false){
      if(typeof(callback) === "function"){
        callback(undefined);
      }
    };

    let items = pasteEvent.clipboardData.items;

    if(items === undefined){
      if(typeof(callback) === "function"){
        callback(undefined);
      }
    };

    for (let i = 0; i < items.length; i++) {
      // Skip content if not image
      if (items[i].type.indexOf("image") === -1) continue;
      // Retrieve image on clipboard as blob
      let blob = items[i].getAsFile();

      // Create an abstract canvas and get context
      let mycanvas = document.createElement("canvas");
      let ctx = mycanvas.getContext('2d');
      
      // Create an image
      let img = new Image();

      let dataURLtoFile = function (dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      }

      // Once the image loads, render the img on the canvas
      img.onload = function(){
        // Update dimensions of the canvas with the dimensions of the image
        mycanvas.width = this.width;
        mycanvas.height = this.height;

        // Draw the image
        ctx.drawImage(img, 0, 0);

        // Execute callback with the base64 URI of the image
        if(typeof(callback) === "function"){
          const base64 = mycanvas.toDataURL((imageFormat || "image/png"))
          const filename = 'image_' + Math.floor(Date.now())
          const arrimg = base64.split(',')[1]

          callback({
            base64: base64,
            width: mycanvas.width,
            height: mycanvas.height,
            type: 'image/png',
            size: Math.floor((new Buffer(arrimg, 'base64').length)),
            filename: filename,
            file: dataURLtoFile(base64, `${filename}.jpg`)
          });
        }
      };

      // Crossbrowser support for URL
      let URLObj = window.URL || window.webkitURL;

      // Creates a DOMString containing a URL representing the object given in the parameter
      // namely the original Blob
      img.src = URLObj.createObjectURL(blob);
    }
  }

  onKeyDown = event => {
    const keyCode = event.keyCode 
    if ( !(keyCode === 8 ||keyCode === 13 || (keyCode >= 37 && keyCode <= 40)) ) {
      let tagNameDisplay = this.state.tagNameDisplay
      tagNameDisplay.tagNameLast = ''
      this.setState({ tagNameDisplay })
    }
  }

  removeNestedTags(element, strvalue) {
    try {
      const children = element.childNodes;
      let indexPosition = 0
      for (let i = children.length - 1; i >= 0; i--) {
        const child = children[i];
        if (child.nodeType === 1 && ['B','I','U'].indexOf(child.nodeName) !== -1) { // Kiểm tra nếu là một thẻ HTML (nodeType = 1)
          let contentInner = child.innerHTML
          let newContent = contentInner.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,'')
          const nodeReplace = document.createElement(child.nodeName)
          nodeReplace.innerHTML = newContent

          element.insertBefore(nodeReplace, child)
          element.removeChild(child)

          if (strvalue && strvalue.indexOf(contentInner) !== -1 && newContent) {
            indexPosition = strvalue.indexOf(contentInner) //+ newContent.length
          }
        } else {
          this.removeNestedTags(child, strvalue)
        }
      }

      return indexPosition
    } catch(e) {
      return 0
    }    
  }

  handleContentEditable = event => {
    try {
      const group_id = this.state.group_id
      let {
        target: { value },
      } = event

      let displayTagflag = false, tagNameDisplay = this.state.tagNameDisplay,
        tagNameLast = '', isEdit = false

      if(value.length === 0){
        try {
          this.checkflagTag = false
          if (this.draft_mess[group_id]) {
            delete this.draft_mess[group_id]
          }
        } catch(e) {}
        this.setState({displayLikeIcon:true})
      }else{
        if(this.state.displayLikeIcon){
          this.setState({displayLikeIcon:false})
        }
      }
      if(value.indexOf('@All') !== -1 || value.indexOf('@all') !== -1){
        this.checkflagAll = true
      } else {
        this.checkflagAll = false
      }
      if (value && value.match(/<span(.*?)<\/span>/g) && value.match(/<span(.*?)<\/span>/g).length > 0) {
        value.match(/<span(.*?)<\/span>/g).map((val) => {
          let arrid = val.match(/"(.*?)"/g)
          if (arrid && arrid[0]) {
            let uid = arrid[0].replace(/"/g, '')
            let cont = />([^;]+)<\/span>/.exec(val) && />([^;]+)<\/span>/.exec(val)[1]
            if (cont && tagNameDisplay[uid] && tagNameDisplay[uid]['name'] && cont !== tagNameDisplay[uid].name) {
              if(Number(uid) === 1){
                value = value.replace(val,cont)
              }else{
                value = value.replace(val, '@' + cont)
              }
              tagNameLast = cont
              isEdit = true
            }
          }
        })
      }
      if(value.indexOf('"') !== -1){
        // console.log(value,'??')  
      }
      
      // if (value.indexOf('@') !== -1) {
      if (this.checkflagTag) {
        displayTagflag = true
      }

      if (value && value.lastIndexOf("\\r") !== -1) {
        value = value.replace(/\\r$/g, "");
      }
      
      if (value && value.indexOf('\\t') !== -1) {
        // value = value.replace(/(\W|^)\\t/g, ' ')
      }

      let valuetmp = this.removeTags(value)
      let strvalue = ''
      if (valuetmp === '' && value !== '') {
        strvalue = ''
      } else {
        strvalue = value
      }
      // strvalue = strvalue.replace(/<br>/g, '')
      strvalue = strvalue.replace(/<\/p><p>/g, '')
      // let messArr = strvalue.split(' ')
      // let lastMessArr = messArr[messArr.length-1]
      // let foundEmoji = this.state.arrTabsChar.indexOf(lastMessArr)
      // let displayEmojiBox = this.state.displayEmojiBox

      // if(displayEmojiBox === true && foundEmoji === -1){
      //   this.setState({displayEmojiBox:false})
      // }

      if (strvalue.indexOf('<b>') !== -1 || strvalue.indexOf('<i>') !== -1 || strvalue.indexOf('<u>') !== -1) {
        let element = new DOMParser().parseFromString(strvalue, 'text/html')
        let contentElement = element.body
        this.removeNestedTags(contentElement, strvalue)
        strvalue = contentElement.innerHTML
        // if (indexPosition > 0) {
        //   setTimeout(() => {
        //     this.setCursor(indexPosition - 8)
        //   }, 200)
        // }
      }      

      if (this.userid && group_id) {
        const me_typing = this.state.me_typing
        if (strvalue) {
          if (me_typing === false) {
            if (this.state.group && this.state.group.occupants_uins && this.state.group.occupants_uins.length < maxUser) {
              rxio.sendGroupEvent(group_id, this.userid, 9)
            }
          }
          let arrGroups = []
          if (strvalue.indexOf('@') !== -1) {
            if (!tagNameLast) {
              let el = document.getElementById("zmess-box")//.firstChild
              let textContent = el.textContent
              const caretOffset = this.getCaret(el)
              this.lastCaretOffset = caretOffset
              tagNameLast = textContent.substring(textContent.lastIndexOf("@") + 1, caretOffset + 1).trim()
            }
            arrGroups = this.state.groupsTagName.filter(o => rxChangeSlug(checkNameUser(o)).indexOf(rxChangeSlug(tagNameLast)) !== -1)
          }
          if (arrGroups.length)
            tagNameDisplay.tagNameLast = tagNameLast

          strvalue = strvalue//.replace(/\&amp\;/g,'&').replace(/\&lt\;/g,'<').replace(/\&gt\;/g,'>')
          
          this.draft_mess[group_id] = strvalue
          this.setState({
            mess: strvalue, 
            me_typing: true,
            displayTagNameBox: displayTagflag,
            groupsTemp: arrGroups,
            tagNameDisplay,
            tagNameQuery: tagNameLast
          }, () => {
            if (tagNameLast && isEdit) {
              var el = document.getElementById("zmess-box").firstChild
              if (el) {
                var range = document.createRange()
                var sel = window.getSelection()
                if (range) {
                  try {
                    el.childNodes.forEach(n => {
                      const regex = new RegExp("@" + tagNameLast, 'g');
                      const result = regex.test(n.textContent)
                      if (result) {
                        // console.log(`${result}-${n.textContent}-${regex.lastIndex}-${n.textContent.charAt(regex.lastIndex)}`)
                        range.setStart(n, regex.lastIndex)
                        range.collapse(true)
                        sel.removeAllRanges()
                        sel.addRange(range)
                      }
                    })
                  } catch (error) { 
                    console.log(error)
                  }
                }
              }
            }
            setTimeout(() => {
              if ((strvalue === this.state.mess) && me_typing) {
                if (this.state.group && this.state.group.occupants_uins.length < maxUser) {
                  rxio.sendGroupEvent(group_id, this.userid, 10)  
                }
                
                this.setState({ me_typing: false })
              }
            }, 2000)
          })
        } else {
          this.setState({
            mess: strvalue, me_typing: true,
            displayTagNameBox: displayTagflag
          }, () => {
            this.props.netaGroupsUpdateMessDraft(group_id,{})
          })
        }

        setTimeout(() => {
          if (strvalue === this.state.mess) {
            this.props.netaMessDrafUpdate(group_id, strvalue)
          }
        }, 200)

      }
    } catch (error) { console.log(error) }
  }

  getCaret(element) {
    if (element) {
      var caretOffset = 0;
      var doc = element.ownerDocument || element.document;
      var win = doc.defaultView || doc.parentWindow;
      var sel;
      if (typeof win.getSelection !== "undefined") {
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
          var range = win.getSelection().getRangeAt(0);
          var preCaretRange = range.cloneRange();
          preCaretRange.selectNodeContents(element);
          preCaretRange.setEnd(range.endContainer, range.endOffset);
          caretOffset = preCaretRange.toString().length;
        }
      } else if ((sel = doc.selection) && sel.type !== "Control") {
        var textRange = sel.createRange();
        var preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
      }
      caretOffset-=1
      return caretOffset;
    }
  }

  tagName_SelectUser=(ele)=> {
    if (!ele) {
      this.checkflagTag = false
      this.setState({displayTagNameBox: false })
    } else {
      let mess = this.state.mess,tagNameLast=this.state.tagNameDisplay.tagNameLast
      mess = mess.replace("<p>","").replace("</p>","").trim()
      let tempTag = '<span uid="' + ele.id + '" class="ztagname" >' + (checkNameUser(ele) || "") + '</span> '
      if (ele && ele.Id && ele.Id === 1) {
        this.checkflagAll = true
      }
      if (tagNameLast) {
        mess = mess.replace(`@${tagNameLast}`, tempTag)
      } else {
        let el = document.getElementById("zmess-box")//.firstChild
        let textContent = el.textContent
        let caretOffset = this.getCaret(el)

        if (caretOffset === -1 && this.lastCaretOffset !== -1) {
          caretOffset = this.lastCaretOffset
        }
        
        let valueReplace = ''
        let posReplace = -1

        if (caretOffset >= 0) {
          for (let i=caretOffset; i >= 0; i--) {
            valueReplace = textContent.charAt(i) + valueReplace 
            // if (textContent.charAt(i) == ' ') {
            //   break
            // }
            if (textContent.charAt(i) == '@') {
              posReplace = i
              break  
            }
          }
        }

        let lastIndex = -1
        for (let index = mess.length-1; index >= 0; index--) {
          if (mess.charAt(index) == '@') {
            lastIndex = index
            break
          }
        }

        if (posReplace != -1) {
          mess = mess.substring(0, lastIndex) + tempTag + mess.substring(lastIndex + valueReplace.length, mess.length)
        }
      }
      if (!mess.startsWith('<p>')) mess = '<p> ' + mess + '</p>'
      const chatDiv = document.getElementById('zmess-box')
      chatDiv.focus()
      let tagNameDisplay = this.state.tagNameDisplay
      tagNameDisplay[ele.id] = { name: checkNameUser(ele) }
      this.checkflagTag = false
      this.setState({ mess: mess, displayTagNameBox: false, tagNameDisplay })  
    }
    
  }

  converEmojiTag(message){
    message = message.replace(/"/g,'\\"')
    const objEmoji = {':)':'🙂',':(':'🙁',':P':'😛',':D':'😃',':O':'😮',';)':'😉','B-)':'🤓','B|':'😎','>:(':'😠',":'(":'😢','O:)':'😇',':*':'😘','3:)':'😈','^_^':'😊','o.O':'😳','>:O':'😫','(y)':'👍',':poop:':'💩'}
    const resMess = message.match(/(:\)|:\(|:P|:D|:O|;\)|B-\)|B\||>:\(|:\/|:'\(|O:\)|:\*|3:\)|\^_\^|o.O|>:O|\(y\)|:poop:)/g)
    if (resMess && resMess.constructor === Array && resMess.length > 0) {
      const uniemoji = [...new Set(resMess)]
      for (let emoji of uniemoji) {
        try {
          let stremoji = emoji.replace(/\)/g,'\\)').replace(/\(/g,'\\(').replace(/\|/g,'\\|').replace(/\//g,'\\/').replace(/'/g,'\\\'').replace(/\*/g,'\\*').replace(/\^/g,'\\^')
          let regEmoji = new RegExp(stremoji, 'g')
          let replaceEmoji = objEmoji[emoji]
          if (replaceEmoji) {
            message = message.replace(regEmoji, replaceEmoji)   
          }
        } catch(e) {}
      }
    }

    return message
  }

  resetTagname(){
    let tagNameDisplay = this.state.tagNameDisplay
    let myDiv = document.getElementById("tagName_List_id");

    if (myDiv) {
      myDiv.scrollTop = 0;
      tagNameDisplay.tagNameLast = ''  
    }

    this.setState({tagNameSelect: '', tagNameSelectNum: 0, tagNameSelect_isFirstTime: true, tagNameDisplay })
  }

  disableDrop = event => {
    event.preventDefault();
  }

  checkTypeUser(username, group_id) {
    if (username) {
      let api_profile = global.rxu.config.base_api_neta + '/api/users/profile/'+encodeURI(username)
      fetch(api_profile, {
        method: 'GET',
        headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
      }).then(res => res.json()).then((json) => {
        if (json.user_type && json.user_type === 1) {
          chatDB.groups.get({group_id: group_id.toString()}).then(groupDB => {
            if (groupDB) {
              chatDB.groups.update(group_id.toString(), { folders: ['2'] }).then(o => {
                this.props.changeGroupFunc()
              }).catch(e => {
                console.log(e)
              })
            }
          })
        } else {
          rxio.socket.emit('update_group', { group_id: Number(group_id), folders: [3] }, (data) => {
            if (data && data.group && data.group.folders && data.group.folders.constructor === Array&& data.group.folders.length > 0) {
              chatDB.groups.get({group_id: group_id.toString()}).then(groupDB => {
                if (groupDB) {
                  chatDB.groups.update(group_id.toString(), { folders: ['3'] }).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => {
                    console.log(e)
                  })
                }
              })
            }
          })
        }
      }).catch(error => {
        console.log("fetch Profile error")
      }) 
    }
  }

  disableNewlines = event => {
    const keyCode = event.keyCode || event.which
    
    if (keyCode == 64) {
      this.checkflagTag = true
    }
    if (event && keyCode === 13 && (event.shiftKey || event.ctrlKey || event.metaKey)) {
      if (event.ctrlKey || event.metaKey) {
        document.execCommand('insertHTML', false, `\n `)
      }
    } else if (keyCode === 13) {
      let group_id = this.state.group.group_id
      // console.log(this.state.group)
      // if (this.netaGroupsDraft && this.netaGroupsDraft.groups && this.netaGroupsDraft.groups[group_id]) {
      //   this.removeDraftGroup(this.state.group)
      // } else {
      if (this.state.group && this.state.group.flagDraf === "0") {
        this.sendMessClick()  
      } else if (this.state.group && (this.state.group.flagDraf === "1" || this.state.group.isDraft === true)) {
        this.removeDraftGroup(this.state.group)
      } else if (this.state.group) {
        this.sendMessClick()
      }
      // }
    }
  }

  sanitize = () => {
    this.setState({ mess: sanitizeHtml(this.state.mess, this.sanitizeConf) })
  }

  removeDraftGroup(group){
    let group_id = group.group_id
    let params = {
      'type':3,
      'occupants_uins':group.occupants_uins
    }
    rxio.checkGroup(params,(data) => {
      console.log('Check Group')
      try {
        if(!data.group){
          this.createNewChat(group.partner_id, group)
        }else{
          if (group.flagDraf === "1") {
            if (!group.partner_id) {
              let arrUins = group.occupants_uins.filter(u => u.toString() !== this.userid.toString())
              group.partner_id = arrUins[0]
            }
            this.createNewChat(group.partner_id, group)
          } else {
            chatDB.groups.get({group_id: group_id.toString()}).then(groupDB => {
              if (groupDB) {
                this.sendMessClick()  
              } else {
                chatDB.groups.add(data.group, data.group.group_id).then(g => {
                  this.sendMessClick()
                }).catch(e => {})
              }
            })
          }
        }
        // this.props.removeGroupsDraft(group.group_id) 
      } catch(e) {}
    })
  }

  createNewChat(partner_id, groupDraft) {
    let userOwner = rxaget(this.props, 'netaauth.user', {})
    const params = {
      'type': 3,
      'owner_uin': userOwner.id,
      'name': '',
      'avatar_url': '',
      'occupants_uins': [userOwner.id.toString(),partner_id],
      'sender_name': ''//userOwner.name
    }

    try {
      if (partner_id) {
        try {
          let messTmp = this.state.mess

          rxio.createNewGroup(params, (data) => {
            if (data && data.group) {
              if (data.group.type === 3) {

                if (data.group && ((data.group.folders && data.group.folders.constructor === Array && data.group.folders.length === 0) || !data.group.folders)) {
                  let partnerId = Number(partner_id)
                  chatDB.users.get({uid: partnerId}).then(userInDB => {
                    if (userInDB) {
                      this.checkTypeUser(userInDB.phone, data.group.group_id)
                    } else {
                      const api_group_detail = global.rxu.config.get_groups + '/' + group_id
                      fetch(api_group_detail, {
                        method: 'GET',
                        headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
                      }).then(res => res.json()).then((json) => {
                        if (json && json.users && json.users.constructor === Array && json.users.length > 0) {
                          let partnerUser = json.users.find(uObj => uObj.Id === partnerId)
                          if (partnerUser) {
                            partnerUser.id = partnerUser.Id
                            partnerUser.uid = partnerUser.Id

                            workerUser.addUser(partnerUser.Id, { id: partnerUser.Id, uid: partnerUser.Id,  ...partnerUser })
                            chatDB.users.put(partnerUser, Number(partnerUser.Id))

                            this.checkTypeUser(partnerUser.phone, data.group.group_id)
                          }
                        }
                      })
                    }
                  })
                }

                let ogroup = data.group
                ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                ogroup.flagDraf = '0' // 0 or 1
                ogroup.flagPin = (ogroup && ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
                ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp

                ogroup.received_list = []
                ogroup.seen_list = []

                const arrUins = rxaget(ogroup, 'occupants_uins', [])

                ogroup['partner_id'] = Number(groupDraft.partner_id) || 0
                ogroup['avatar_url'] = groupDraft.avatar_url || ''
                ogroup['group_fullname'] = groupDraft.group_fullname || ''
                ogroup.count_unread = 0
                
                this.props.chooseGroupAction(ogroup) 

                workerUnread.initUnread(ogroup.group_id.toString(), '-1')
                chatDB.groups.add(ogroup, ogroup.group_id).then(g => {
                  this.props.changeGroupFunc()
                }).catch(e => {})


                this.props.removeGroupsDraft(ogroup.group_id) 
                this.props.netaGroupsRemove(ogroup.group_id)
                this.props.netaMessRemove(ogroup.group_id)                  

                setTimeout(() => {
                  this.sendMessClick(ogroup.group_id, messTmp)
                  this.setState({ group: ogroup })
                }, 200)
                
              }         
            }
          })
        } catch(e1) {
        }
      }
    } catch(e) {
    }  
  }

  handleMessage(data, scroll, cond) {
    let elem = document.getElementById('chat-value')
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chatInput', { detail: {data: data, scroll: scroll, cond: cond } }))
    }
  }

  sendMessClick(groupIdTmp, messTmp){
      const imageTmp = this.state.imageTmp || {}

      let group_id = groupIdTmp || this.state.group_id
      
      let displayTagNameBox = this.state.displayTagNameBox
      let groupsTemp = this.state.groupsTemp
      let mentioned_uins = []
      let mentioned_all = false

      if (imageTmp && imageTmp.base64) {  
        if (!this.blockEnter) {
          this.uploadThumnail(imageTmp, (data) => {
            if (data) {
              this.uploadFile([data], 'image')  
            } else {
              alert('Upload Image Unsuccess')
            }

            this.setState({imageTmp: {}})
          })  
        }
      } else {
        if (displayTagNameBox === true && groupsTemp && groupsTemp.length > 0 && this.state.tagNameSelect ){          
          this.tagName_SelectUser(this.state.tagNameSelect)
          this.resetTagname()
          /*let tagNameDisplay = this.state.tagNameDisplay
          let myDiv = document.getElementById("tagName_List_id");
          myDiv.scrollTop = 0;
          tagNameDisplay.tagNameLast = ''

          this.setState({ tagNameSelect: '', tagNameSelectNum: 0, tagNameSelect_isFirstTime: true, tagNameDisplay })*/
        } else {          

          // event.returnValue = false
          // if (event.preventDefault) {
          //   event.preventDefault()
            let mess = messTmp || this.state.mess      
            let emptyMess = mess.replace(/[\s]/g, '')
            if(this.state.type_option === 2 || emptyMess.length > 0 ){

              mess = this.converEmojiTag(mess)
              if (mess && mess.match(/<span(.*?)<\/span>/g) && mess.match(/<span(.*?)<\/span>/g).length > 0) {
                mess.match(/<span(.*?)<\/span>/g).map((val) => {
                  if (val.indexOf('uid') !== -1) {
                    let arrid = val.match(/"(.*?)"/g)
                    if (arrid && arrid[0]) {
                      let uid = arrid[0].replace(/\\"/g,'').replace(/"/g,'')
                      if(uid.toString() !== '1' ){
                        mess = mess.replace(val, '@'+uid+' ')
                        mentioned_uins.push(uid)
                      }else{
                        mentioned_all = true
                      }
                    }
                  }
                })
              }
              mess = this.removeTags(mess)



              if (group_id && (this.state.type_option === 2 || typeof mess !== 'boolean')) {
                let msg_message =  ''
                if(mess && typeof mess !== 'boolean'){
                  msg_message = mess.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
                }
                let msg = {
                  group_id: group_id,
                  type: 0,
                  nonce: Math.floor(Date.now()).toString(),
                  sender_name: '',//rxaget(this.props, 'netaauth.user.name', ''),
                  message: msg_message
                }
                if ([1, 2].indexOf(this.state.type_option) !== -1 && this.state.mess_selected && this.state.mess_selected.message_id) {
                  let attachments = {
                    created_at: rxaget(this.state.mess_selected, 'created_at', '').toString(),
                    group_id: rxaget(this.state.mess_selected, 'group_id', '').toString(),
                    group_type: Number(rxaget(this.state.mess_selected, 'group_type', 0)),
                    message: rxaget(this.state.mess_selected, 'message', ''),
                    message_id: rxaget(this.state.mess_selected, 'message_id', '').toString(),
                    sender_uin: rxaget(this.state.mess_selected, 'sender_uin', '').toString(),
                    status: Number(rxaget(this.state.mess_selected, 'status', 0)),
                    // type: Number(rxaget(this.state.mess_selected, 'type', 0)),
                    version: Number(rxaget(this.state.mess_selected, 'version', 0))
                  }              
                  let sub_attachments_tmp = ''
                  try {
                    let s_attachments = this.state.mess_selected.attachments && JSON.parse(this.state.mess_selected.attachments)
                    if (this.state.mess_selected.type === 3) attachments.audio = s_attachments.audio
                    else if (this.state.mess_selected.type === 12) attachments.file = s_attachments.file
                    else if (this.state.mess_selected.type === 4) attachments.video = s_attachments.video
                  } catch (error) { }
                  if (rxaget(this.state.mess_selected, 'attachments', '') !== '') {
                    let messType = rxaget(this.state.mess_selected, 'type', '')
                    
                    if([2, 3, 4, 10, 12].indexOf(messType) !== -1){
                      try {
                        let attachments_tmp = rxaget(this.state.mess_selected, 'attachments', '')
                        attachments.attachments = '[attachments_conditional]'
                        attachments.type = Number(rxaget(this.state.mess_selected, 'type', 0))
                        sub_attachments_tmp =JSON.stringify(JSON.parse(attachments_tmp)).replace(/"/g, '\\\\\\"')
                      } catch (e) {
                        console.log(e)
                      }
                    } 
                    if([8].indexOf(messType) !== -1){
                      try {
                        let attachments_tmp = {}
                        attachments_tmp.type = 'text'
                        attachments_tmp.text = rxaget(this.state.mess_selected, 'message', '')
                        attachments.attachments = '[attachments_conditional]'
                        attachments.type = 0
                        sub_attachments_tmp =JSON.stringify(attachments_tmp).replace(/"/g, '\\\\\\"')
                      } catch (e) {
                        console.log(e)
                      }
                    } 

                    if([9].indexOf(messType) !== -1){
                      try {
                        if (this.state.mess_selected && this.state.mess_selected.message === "" && this.state.mess_selected.attachments !== "") {
                          try {
                            let attachments_forward = JSON.parse(this.state.mess_selected.attachments)
                            if (attachments_forward && attachments_forward.attachments !== "" && attachments_forward.message === "") {
                              attachments.attachments = '[attachments_conditional]'
                              attachments.type = Number(rxaget(attachments_forward, 'type', 0))
                              sub_attachments_tmp = JSON.stringify(JSON.parse(attachments_forward.attachments)).replace(/"/g, '\\\\\\"')
                            } else {
                              attachments = attachments_forward
                            }
                          } catch(e4) {}
                        }
                      } catch (e) {
                        console.log(e)
                      }
                    }
                  }
                  try {
                    let messattach = attachments.message || ''
                    attachments.message = messattach.replace(/"/g, '\'\'')
                  } catch(e2) {}    
                  attachments = JSON.stringify(attachments).replace(/"/g, '\\"')
                  msg = {
                    group_id: Number(group_id),
                    type: (this.state.type_option === 1) ? 8 : 9,
                    version: 1,
                    sender_name: rxaget(this.props, 'netaauth.user.name', ''),
                    nonce: Math.floor(Date.now()).toString(),
                    message: msg_message,
                    attachments: attachments.replace('[attachments_conditional]',sub_attachments_tmp)
                  }

                }

                if (rxio.connected) {
                  if (!this.blockEnter) {
                    this.blockEnter = true
                    if (msg && msg.message) {
                      if (msg.message.indexOf('&') !== -1) {
                        msg.message = msg.message.replace(/\&amp\;/g,'&').replace(/\&lt\;/g,'<').replace(/\&gt\;/g,'>')  
                      }
                      if (msg.message.indexOf('\\\\\\\"') !== -1) {
                        msg.message = msg.message.replace(/\\\\\\\"/g, '\\\"')
                      }
                      if (msg.message.indexOf('\\\\n') !== -1) {
                        msg.message = msg.message.replace(/\\\\n/g, '\\\\\\\\n')
                      }
                    }

                    if (this.draft_mess && this.draft_mess[msg.group_id]) {
                      delete this.draft_mess[msg.group_id]
                    }

                    msg.mentioned_uins = mentioned_uins
                    msg.mentioned_all = mentioned_all
                    this.checkflagAll = false
                    rxio.socket.emit('create_message', msg, (data) => {
                      rxio.resetCountTime()
                      if (data && data.message) {
                        this.blockEnter = false
                        this.checkflagTag = false
                        this.setState({ type_option: 0, mess_selected: {}/*, mess: ''*/,displayTagNameBox: false,tagNameDisplay: {}, me_typing: false, displayLikeIcon: true}, () => {
                          // this.props.netaMessAdd(group_id, data.message)
                          this.handleMessage(data.message, true, 'footer')

                          workerGroup.addGroup(group_id, data.message)

                          try {
                            chatDB.mess.add(data.message, data.message.message_id.toString()).then(m => {}).catch(e => {})
                          } catch(e) {}

                          chatDB.groups.get({group_id: group_id}).then(groupInDB => {
                            if (groupInDB) {
                              groupInDB.last_message = data.message
                              groupInDB.last_message_id = data.message.message_id
                              groupInDB.last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + data.message.created_at
                              groupInDB.count_unread = 0
                              groupInDB.my_seen_mess = data.message.message_id
                              workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                              chatDB.groups.put(groupInDB, group_id.toString()).then((updated) => {
                                this.props.changeGroupFunc(group_id)
                              });  
                            }
                          })

                          if (this.state.group && this.state.group.occupants_uins && this.state.group.occupants_uins.length < maxUser) {
                            rxio.sendGroupEvent(group_id, this.userid, 10)  
                          }
                          
                        })
                        // this.props.reloadStateWhenRepMess(data)
                      }
                    })
                    setTimeout(() => {
                      this.blockEnter = false
                    }, 1000)
                  }
                }           
                // this.props.updateRecentContactGroups(this.state.group.partner_id,Date.now())  
                this.props.netaMessDrafUpdate(group_id, '')
                this.setState({mess:''})
              }
            
            }

          // }
        }
      }
    // }
  }

  sendMessForwardReply(){
      const imageTmp = this.state.imageTmp || {}

      let group_id = this.state.group_id

      let displayTagNameBox = this.state.displayTagNameBox
      let groupsTemp = this.state.groupsTemp
      if (imageTmp && imageTmp.base64) {  
        if (!this.blockEnter) {
          this.uploadThumnail(imageTmp, (data) => {
            if (data) {
              this.uploadFile([data], 'image')  
            } else {
              alert('Upload Image Unsuccess')
            }

            this.setState({imageTmp: {}})
          })  
        }
      } else {
        if (displayTagNameBox === true && groupsTemp && groupsTemp.length > 0 && this.state.tagNameSelect ){          
          this.tagName_SelectUser(this.state.tagNameSelect)
          this.resetTagname()
          /*let tagNameDisplay = this.state.tagNameDisplay
          let myDiv = document.getElementById("tagName_List_id");
          myDiv.scrollTop = 0;
          tagNameDisplay.tagNameLast = ''

          this.setState({ tagNameSelect: '', tagNameSelectNum: 0, tagNameSelect_isFirstTime: true, tagNameDisplay })*/
        } else {          
          // event.returnValue = false
          // if (event.preventDefault) {
          //   event.preventDefault()
            let mess = this.state.mess      
            let emptyMess = mess.replace(/[\s]/g, '')
            if(this.state.type_option === 2 || emptyMess.length > 0 ){

              mess = this.converEmojiTag(mess)
              if (mess && mess.match(/<span(.*?)<\/span>/g) && mess.match(/<span(.*?)<\/span>/g).length > 0) {
                mess.match(/<span(.*?)<\/span>/g).map((val) => {
                  if (val.indexOf('uid') !== -1) {
                    let arrid = val.match(/"(.*?)"/g)
                    if (arrid && arrid[0]) {
                      let uid = arrid[0].replace(/\\"/g,'').replace(/"/g,'')
                      mess = mess.replace(val, '@'+uid+' ')
                    }
                  }
                })
              }
              mess = this.removeTags(mess)



              if (group_id && (this.state.type_option === 2 || typeof mess !== 'boolean')) {
                let msg_message =  ''
                if(typeof mess !== 'boolean'){
                  msg_message = mess.replace(/\\/g, '\\\\').replace(/"/g, '\\"')
                }
                let msg = {
                  group_id: group_id,
                  type: 0,
                  nonce: Math.floor(Date.now()).toString(),
                  sender_name: rxaget(this.props, 'netaauth.user.name', ''),
                  message: msg_message
                }
                if ([1, 2].indexOf(this.state.type_option) !== -1 && this.state.mess_selected && this.state.mess_selected.message_id) {
                  let attachments = {
                    created_at: rxaget(this.state.mess_selected, 'created_at', '').toString(),
                    group_id: rxaget(this.state.mess_selected, 'group_id', '').toString(),
                    group_type: Number(rxaget(this.state.mess_selected, 'group_type', 0)),
                    message: rxaget(this.state.mess_selected, 'message', ''),
                    message_id: rxaget(this.state.mess_selected, 'message_id', '').toString(),
                    sender_uin: rxaget(this.state.mess_selected, 'sender_uin', '').toString(),
                    status: Number(rxaget(this.state.mess_selected, 'status', 0)),
                    // type: Number(rxaget(this.state.mess_selected, 'type', 0)),
                    version: Number(rxaget(this.state.mess_selected, 'version', 0))
                  }              
                  let sub_attachments_tmp = ''
                  try {
                    let s_attachments = this.state.mess_selected.attachments && JSON.parse(this.state.mess_selected.attachments)
                    if (this.state.mess_selected.type === 3) attachments.audio = s_attachments.audio
                    else if (this.state.mess_selected.type === 12) attachments.file = s_attachments.file
                    else if (this.state.mess_selected.type === 4) attachments.video = s_attachments.video
                  } catch (error) { }
                  if (rxaget(this.state.mess_selected, 'attachments', '') !== '') {
                    let messType = rxaget(this.state.mess_selected, 'type', '')
                    if([2, 3, 4, 10, 12].indexOf(messType) !== -1){
                      try {
                        let attachments_tmp = rxaget(this.state.mess_selected, 'attachments', '')
                        attachments.attachments = '[attachments_conditional]'
                        attachments.type = Number(rxaget(this.state.mess_selected, 'type', 0))
                        sub_attachments_tmp =JSON.stringify(JSON.parse(attachments_tmp)).replace(/"/g, '\\\\\\"')
                      } catch (e) {
                        console.log(e)
                      }
                    } 
                    if([8].indexOf(messType) !== -1){
                      try {
                        let attachments_tmp = {}
                        attachments_tmp.type = 'text'
                        attachments_tmp.text = rxaget(this.state.mess_selected, 'message', '')
                        attachments.attachments = '[attachments_conditional]'
                        attachments.type = 0
                        sub_attachments_tmp =JSON.stringify(attachments_tmp).replace(/"/g, '\\\\\\"')
                      } catch (e) {
                        console.log(e)
                      }
                    } 

                    if([9].indexOf(messType) !== -1){
                      try {
                        if (this.state.mess_selected && this.state.mess_selected.message === "" && this.state.mess_selected.attachments !== "") {
                          try {
                            let attachments_forward = JSON.parse(this.state.mess_selected.attachments)
                            if (attachments_forward && attachments_forward.attachments !== "" && attachments_forward.message === "") {
                              attachments.attachments = '[attachments_conditional]'
                              attachments.type = Number(rxaget(attachments_forward, 'type', 0))
                              sub_attachments_tmp = JSON.stringify(JSON.parse(attachments_forward.attachments)).replace(/"/g, '\\\\\\"')
                            } else {
                              attachments = attachments_forward
                            }
                          } catch(e4) {}
                        }
                      } catch (e) {
                        console.log(e)
                      }
                    }
                  }
                  try {
                    let messattach = attachments.message || ''
                    attachments.message = messattach.replace(/"/g, '\'\'')
                  } catch(e2) {}    
                  attachments = JSON.stringify(attachments).replace(/"/g, '\\"')
                  msg = {
                    group_id: Number(group_id),
                    type: (this.state.type_option === 1) ? 8 : 9,
                    version: 1,
                    sender_name: rxaget(this.props, 'netaauth.user.name', ''),
                    nonce: Math.floor(Date.now()).toString(),
                    message: msg_message,
                    attachments: attachments.replace('[attachments_conditional]',sub_attachments_tmp)
                  }

                }

                if (rxio.connected) {
                  if (msg && msg.message) {
                    if (msg.message.indexOf('&') !== -1) {
                      msg.message = msg.message.replace(/\&amp\;/g,'&').replace(/\&lt\;/g,'<').replace(/\&gt\;/g,'>')  
                    }
                    if (msg.message.indexOf('\\\\\\\"') !== -1) {
                      msg.message = msg.message.replace(/\\\\\\\"/g, '\\\"')
                    }
                  }

                  if (this.draft_mess && this.draft_mess[msg.group_id]) {
                    delete this.draft_mess[msg.group_id]
                  }
                  this.checkflagAll = false
                  rxio.socket.emit('create_message', msg, (data) => {
                    if (data && data.message) {
                      if (data.message.message_id) {
                        chatDB.groups.get({group_id: group_id}).then(groupInDB => {
                          if (groupInDB) {
                            let paramsUpdateGroup = {
                              last_message: data.message,
                              last_message_id: data.message.message_id,
                              last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + data.message.created_at,
                              count_unread: 0,
                              my_seen_mess: data.message.message_id
                            }
                            workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                            chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                              this.props.changeGroupFunc()
                            }).catch(e => {})
                          }
                        })  
                      }
                      this.checkflagTag = false
                      this.setState({ type_option: 0, mess_selected: {}/*, mess: ''*/,displayTagNameBox: false,tagNameDisplay: {}, me_typing: false, displayLikeIcon: true}, () => {
                        this.props.netaMessAdd(group_id, data.message)
                        this.handleMessage(data.message, true, 'footer')
                        rxio.sendGroupEvent(group_id, this.userid, 10)
                      })
                      // this.props.reloadStateWhenRepMess(data)
                    }
                  })  
                }           
                // this.props.updateRecentContactGroups(this.state.group.partner_id,Date.now())  
                this.props.netaMessDrafUpdate(group_id, '')
                this.setState({mess:''})
              }
            
            }

          // }
        }
      }
    // }
  }


  uploadThumnail(image, callback) {
    if (image.base64 && image.width > 0) {
      let dataParams = {
        content_type: image.type,
        name: image.filename,
        public: true,
        size: image.size
      }
      let header = { 'TC-Token': this.token, 'Content-Type': 'application/json; charset=UTF-8', 'Accept-Encoding': 'gzip', 'Connection': 'keep-alive' }
      let requestOptions = {
        method: 'POST',
        headers: header,
        body: JSON.stringify(dataParams),
        redirect: 'follow'
      };

      fetch(global.rxu.config.create_blob, requestOptions).then(res => res.json()).then((json) => {
        this.blockEnter = true
        if (json && json.blod_object && json.blod_object.form_data) {
          let dataUpload = new FormData()
          let arrKeys = ['Content-Type', 'key', 'policy', 'x-amz-algorithm', 'x-amz-credential', 'x-amz-date', 'x-amz-meta-netachat', 'x-amz-signature']
          for (let key of arrKeys) {
            if (json.blod_object.form_data[key]) {
              dataUpload.append(key, json.blod_object.form_data[key])
            }
          }
          dataUpload.append('file', image.file, image.file.name)
          dataUpload.append('success_action_status', 201)

          fetch(json.blod_object.params, { method: 'POST', body: dataUpload }).then(resBlob => resBlob.text()).then(result => {
            if (result.indexOf('Key') !== -1) {
              let patt = '<Key.*?>(.*?)<\\/Key>';
              let strresult = result.match(patt);
              if (strresult && strresult.constructor === Array && strresult.length > 1) {
                let key = strresult[1]
                if (key) {
                  let optComplete = {
                    method: 'PUT',
                    headers: header,
                    body: JSON.stringify({
                      content_type: json.content_type,
                      id: json.id,
                      name: json.name,
                      size: json.size,
                      uid: json.uid
                    })
                  };

                  fetch(global.rxu.config.get_blobs + '/' + json.id + '/complete.json', optComplete)
                    .then(response => {
                      if (response.status === 200) {
                        try {
                          let objSize = {
                            width: image.width || 960,
                            height: image.height || 720,
                            url: key
                          }
                          
                          callback(objSize)
                        } catch (e) {
                          callback(undefined)
                        }
                      } else {
                        callback(undefined)
                      }
                    })
                    .catch(errorPut => console.log('error', errorPut));
                } else {
                  callback(undefined)
                }
              } else {
                callback(undefined)
              }
            } else {
              callback(undefined)
            }
          })
        } else {
          callback(undefined)
        }
      }).catch(error => console.log('error', error))
    } else {
      callback(undefined)
    }
  }

  setCursor(pos) {
    try {
      var chatDiv = document.getElementById('zmess-box')
      var range = document.createRange();
      var sel = window.getSelection();
      range.setStart(chatDiv.childNodes[0], pos);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      chatDiv.focus();
    } catch(e) {}
  }

  delay(delayInms) {
    return new Promise(resolve => setTimeout(resolve, delayInms));
  }

  async sendLike() {
    const arrUsers = this.state.users
    const group_id = this.state.group_id
    const user = rxaget(this.props, 'netaauth.user', {})
    const msg = {
      group_id: group_id,
      type: 0,
      version: 1,
      nonce: Math.floor(Date.now()).toString(),
      sender_name: '',
      message: '👍'
    }

    const objUser = arrUsers[user.id.toString()]
    if (objUser && objUser.profile_url) {
      msg.sender_avatar = objUser.profile_url
    }
    if (rxio.connected) {
      rxio.socket.emit('create_message', msg, (data) => {
        if (data && data.message) {

          if (data.message.message_id) {
            chatDB.groups.get({group_id: group_id}).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  last_message: data.message,
                  last_message_id: data.message.message_id,
                  last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + data.message.created_at,
                  count_unread: 0
                }

                chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => {})
              }
            })  
          }

          this.handleMessage(data.message, true)
          this.props.netaMessDrafUpdate(group_id, '')
        }
      })  
    }
  }

  timeout(delay) {
    return new Promise( res => setTimeout(res, delay) );
  }

  async sendTest() {
    // let j=301
    // for (let i=j; i < j+60; i++) {
    //   console.log(i)
    //   await this.timeout(500);
    //   await this.testSend(i)
    // }
  }

  sendSticker(value) {
    const arrUsers = this.state.users
    const group_id = this.state.group_id
    const user = rxaget(this.props, 'netaauth.user', {})
    const objUser = arrUsers[user.id.toString()]

    const msg = {
      group_id: Number(group_id),
      type: 10,
      version: 1,
      nonce: (Math.floor(Date.now()) * 1000).toString(),
      sender_name: (objUser && objUser.full_name) ? objUser.full_name : '',
      attachments: '{\\"sticker\\":\\"' + value + '\\"}'
    }
    if (rxio.connected) {
      rxio.socket.emit('create_message', msg, (data) => {
        if (data && data.message) {

          if (data.message.message_id) {
            chatDB.groups.get({group_id: group_id}).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  last_message: data.message,
                  last_message_id: data.message.message_id,
                  last_sort: '1' + groupInDB.flagDraf + groupInDB.flagPin + data.message.created_at,
                  my_seen_mess: data.message.message_id,
                  count_unread: 0
                }
                workerUnread.initUnread(groupInDB.group_id.toString(), '-1')
                chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => {})
              }
            })  
          }

          this.handleMessage(data.message, true)
          this.props.netaMessDrafUpdate(group_id, '')
        }
      })  
    }
  }

  addEmoji(value, type) {
    if (type === 'EmojiIcon') {
      const chatDiv = document.getElementById('zmess-box')
      if (chatDiv) {
        chatDiv.innerHTML += value
        this.setState({ mess: chatDiv.innerHTML })

        //Handle Focus input chat
        try {
          const selObj = window.getSelection();
          const end = chatDiv.textContent.length;
          const range = document.createRange()
          range.setStart(chatDiv.childNodes[0], end)
          range.collapse(true)
          selObj.removeAllRanges()
          selObj.addRange(range)
          chatDiv.focus()
        } catch(e) {}        
      }
    } else if (type === 'Sticker') {
      this.sendSticker(value)
    }
  }

  fetchImage(src, callback) {
    try {
      if (!this.checkImage[src]) {
        this.checkImage[src] = true

        fetch(src, { headers: { 'TC-Token': this.token }, redirect: 'follow' })
          .then(res => {
            if (res && res.redirected && res.url && src) {
              try {
                this.props.netaBlobsUpdate(src, res.url)
              } catch (e) {
                console.log(e)
              }
            }
            return res.blob()
          })
          .then(blob => {
            var reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onloadend = () => {
              if (reader.result) {
                callback(reader.result)
              }
            }
          })
      }
    } catch (e) {
      // console.log(e)
    }
  }

  onClickMouseRight(e) {
    const menuDiv = document.getElementById('menu-footer')
    // const menuDivGroup = document.getElementById('context_menu-group')
    if (menuDiv && e.button === 2) {
      
      document.oncontextmenu = function () {
        return false;
      }
      menuDiv.style.top = (Number(e.clientY) - 70) + 'px'
      menuDiv.style.left = (Number(e.clientX)) + 'px'
      menuDiv.style.display = 'block'
    }
  }

  async chooseOptionFooter(e, type) {
    if (type === 'copy') {
    } else if (type === 'cut') {
    } else if (type === 'paste') {
      try {
        const clipboardItems = await navigator.clipboard.read() 
        if (clipboardItems && clipboardItems.constructor === Array && clipboardItems.length > 0 && clipboardItems[0]) {
          if (clipboardItems[0].types && clipboardItems[0].types.indexOf('text/html') !== -1 ) {
            clipboardItems[0].getType('text/html').then((textData) => {
              const reader = new FileReader()
              reader.addEventListener('loadend', (e) => {
                let text = e.srcElement.result;
                if (text) {
                  text = text.replace(/<span(?:(?!uid).)*?>/g, '<span>')
                }
                let newText = sanitizeHtml(text, this.sanitizeConf).replace(/<p>/gi, '').replace(/<\/p>/gi, '\n').replace(/&nbsp;/g, ' ').replace(/\xA0/g,' ').replace(/<br>/g,'\n')
                
                if (newText) {
                  newText = newText.trim()

                  if (newText.indexOf('[') !== -1) {
                    newText = newText.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<b>$1</b>')
                    newText = newText.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
                    newText = newText.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
                  }
                }

                this.setCursor(newText.length)
                this.setState({mess: newText}) 
              })
              reader.readAsText(textData)
            })
          } else {
            const text = await navigator.clipboard.readText()
            document.getElementById('zmess-box').innerText = text
            // setTimeout(() => {
              let textInnerHtml = document.getElementById('zmess-box')
              if (textInnerHtml) {
                let textValue = textInnerHtml.innerHTML.replace(/<br>/g,'\n') 
                if (textValue) {
                  textValue = textValue.trim()

                  if (textValue.indexOf('[') !== -1) {
                    textValue = textValue.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<b>$1</b>')
                    textValue = textValue.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
                    textValue = textValue.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
                  }
                }
                this.setCursor(textValue.length)
                this.setState({mess: textValue}) 
              }
            // }, 50)
          }
        }
      } catch(e) {
        console.log(e)
      }
    }

    const menuDiv = document.getElementById('menu-footer')
    if (menuDiv) {
      menuDiv.style.display = 'none' 
    }
  }



  isLeader(eleId){
    let group = this.state.group
    return isLeaderCheck(eleId,group)
  }

  handleDragOut(e) {
  }

  sendPollMess(pollInfo, pinStatus, poll_type) {
    const arrUsers = this.users
    const group_id = this.state.group_id
    const user = rxaget(this.props, 'netaauth.user', {})
    // let poll_type = pollInfo.poll_type || 0
    pollInfo.poll_type = poll_type
    let opollInfo
    opollInfo = this.handlePollInfoDataBeforeCreateMess(pollInfo)
    let attachments = JSON.stringify(opollInfo)
    const msg = {
      group_id: group_id,
      // type: type,
      type: 17,
      version: 1,
      nonce: Math.floor(Date.now()).toString(),
      sender_name: rxaget(this.props, 'netaauth.user.name', ''),
      attachments: attachments
    }

    const objUser = arrUsers[user.id.toString()]
    if (objUser && objUser.profile_url) {
      msg.sender_avatar = objUser.profile_url
    }
    if (poll_type === 2 || poll_type === 3) {
      let currentMsg = pollInfo.currentMsg
      msg.message_origin_id = pollInfo.message_id 
      msg.group_origin_id = group_id
    }
    if(poll_type === 4 ){
      this.resendPollMess(pollInfo, pinStatus, 1)      
    }
    if (rxio.connected) {
      rxio.socket.emit('create_message', msg, async (data) => {
        if (data && data.message) {

          if (data.message.message_id) {
            if(poll_type === 1){
              await this.updatePoll(data.message.message_id,pollInfo,group_id)
            }
            chatDB.groups.get({ group_id: group_id }).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  isDraft: false,
                  last_message: data.message,
                  last_message_id: data.message.message_id,
                  last_sort: '1' + groupInDB.flagPin + groupInDB.flagDraf + data.message.created_at,
                  count_unread: 0,
                  timestamp: data.message.created_at
                }

                chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            })
          }
          if (pinStatus) {
            this.pinPoll(data)
          }
          this.handleMessage(data.message, true)
        }
      })
    }
  }

  updatePoll(message_id,pollInfo,group_id){
    let params = {
      "group_id": group_id.toString(),
      "poll_id": pollInfo.poll_id,
      "message_id": message_id
    }
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.token }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_update'), {
      method: 'PUT',
      body: JSON.stringify(params),
      headers: headers 
    })
    .then((res) => { return res.json() })
    .then(async (json) => {
      if(json ){
        pollInfo.message_id = message_id
        
        let foundPollInfo = false
        let polls = await chatDB.polls.get({ group_id: group_id })
        let pollsArr = polls.data
        for (let i = 0; i < pollsArr.length; i++) {
          if (pollInfo.poll_id === pollsArr[i].poll_id) {
            let pollTmp = {...pollsArr[i] }
            pollTmp.message_id = message_id
            pollsArr[i] = { ...pollTmp }
            foundPollInfo = true
          }
        }
        if(!foundPollInfo){
          let pollInfoTmp = await this.getPollById(pollInfo.poll_id)
          pollsArr.push(pollInfoTmp)
        }

        let params = {
          group_id: group_id,
          data: pollsArr,
        }
        await chatDB.polls.put(params, group_id.toString()).then(() => {
          this.props.changePollsFunc()
        })
      }
    }).catch(er => console.log(er))
  }

  // async getPollItem(poll_id, group_id) {
  //   let polls = await chatDB.polls.get({ group_id: group_id })
  //   let pollsArr = polls.data

  //   let pollItem = pollsArr.find(o => o.poll_id === poll_id)
  //   return pollItem
  // }

  async getPollById(poll_id){
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8',  'TC-Token': this.token }
    let pollInfo = await fetch(global.rxu.get(global.rxu.config, 'api_get_poll')+poll_id, {
      method: 'GET',
      body: null,
      headers: headers 
    })

    return pollInfo.json()
  }

  resendPollMess(pollInfo, pinStatus, poll_type) {
    let pinMessStatus = pollInfo.pinMessStatus 
    const arrUsers = this.users
    const group_id = this.state.group_id
    const user = rxaget(this.props, 'netaauth.user', {})
    // let poll_type = pollInfo.poll_type || 0
    pollInfo.poll_type = poll_type
    let opollInfo
    opollInfo = this.handlePollInfoDataBeforeCreateMess(pollInfo)
    let attachments = JSON.stringify(opollInfo)
    const msg = {
      group_id: group_id,
      // type: type,
      type: 17,
      version: 1,
      nonce: Math.floor(Date.now()).toString(),
      sender_name: rxaget(this.props, 'netaauth.user.name', ''),
      attachments: attachments
    }

    const objUser = arrUsers[user.id.toString()]
    if (objUser && objUser.profile_url) {
      msg.sender_avatar = objUser.profile_url
    }
    // if (poll_type === 2 || poll_type === 3) {
    //   let currentMsg = pollInfo.currentMsg
    //   msg.message_origin_id = currentMsg.message_id
    //   msg.group_origin_id = group_id
    // }
    // if(poll_type === 4 ){
    //   let currentMsg = pollInfo.currentMsg
    //   msg.sender_origin_id = this.userid.toString()
    //   msg.message_origin_id = currentMsg.message_id
    //   msg.group_origin_id = group_id
      
    // }
    let currentMsg = pollInfo.currentMsg
    msg.sender_origin_id = this.userid.toString()
    msg.message_origin_id = pollInfo.message_id 
    msg.group_origin_id = group_id
    if (rxio.connected) {
      rxio.socket.emit('create_message', msg, async(data) => {
        if (data && data.message) {

          if (data.message.message_id) {
            if(poll_type === 1){
              await this.updatePoll(data.message.message_id,pollInfo,group_id)
            }
            if(pinMessStatus === 2){
              this.repinPoll(data)
            }
            chatDB.groups.get({ group_id: group_id }).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  isDraft: false,
                  last_message: data.message,
                  last_message_id: data.message.message_id,
                  last_sort: '1' + groupInDB.flagPin + groupInDB.flagDraf + data.message.created_at,
                  count_unread: 0,
                  timestamp: data.message.created_at
                }

                chatDB.groups.update(rxaget(groupInDB, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            })
          }
          if (pinStatus) {
            this.pinPoll(data)
          }
          this.handleMessage(data.message, true)
        }
      })
    }
  }

  handlePollInfoDataBeforeCreateMess(pollInfo) {
    let params
    let answers = pollInfo.answers
    for (let i = 0; i < answers.length; i++) {
      answers[i].users = []
    }
    params = {
      answers: answers,
      group_id: pollInfo.group_id,
      poll_id: pollInfo.poll_id,
      message_id: pollInfo.message_id,
      question: pollInfo.question,
      status: pollInfo.status,
      total_user_voted: pollInfo.total_user_voted,
      poll_type: pollInfo.poll_type || 0,
      user_answers_uin:pollInfo.user_answers_uin || [],
      isFirstVote:pollInfo.isFirstVote || false
    }
    return params
  }

  pinPoll(data) {
    let elem = document.getElementById('chat-value')
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chatInput', { detail: { data: data, scroll: true, cond: '', type: 'pinPoll' } }))
    }
  }

  repinPoll(data) {
    let elem = document.getElementById('chat-value')
    if (elem) {
      elem.dispatchEvent(new CustomEvent('chatInput', { detail: { data: data, scroll: true, cond: '', type: 'repinPoll' } }))
    }
  }
  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  langValue: state.langValue,
  user: state.user,
  auth: state.auth,
  favorite: state.favorite,
  netaauth: state.netaauth,
  // netaGroups: state.netaGroups,  
  rxgroup: state.rxgroup,
  themeValue: state.themeValue,
  tabmore: state.tabmore,
  netaGroupsDraft: state.netaGroupsDraft,
  netaMessDraf: state.netaMessDraf
})

const mapDispatchToProps = {
  changeGroupFunc,
  netaMessAdd,
  updateRecentContactGroups,
  chooseGroupAction,
  netaMediaOneAdd,
  netaGroupsUpdateMessDraft,
  netaGroupsRemove,
  netaMessRemove,
  removeGroupsDraft,
  netaMessDrafUpdate,
  changePollsFunc

}

const FooterChatWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterComponent_)

export default FooterChatWrapped